/**
 * Centralized, environment-driven feature flags.
 *
 * Flags are read from Create React App compile-time env vars (REACT_APP_*),
 * so their values are baked into each environment's build artifact. The CI
 * workflow (.github/workflows/deploy.yml) sets these per environment.
 */

/**
 * Controls whether the Legal Mailing workflow is available.
 *
 * Enabled on staging/development, disabled on production until the workflow
 * is ready to ship. When disabled, the "Legal Mailing" option is hidden from
 * the Upload Mailing menu and the /create-notice/legal/* routes redirect home.
 *
 * Set via REACT_APP_LEGAL_MAILING_ENABLED ("true" to enable).
 */
export const isLegalMailingEnabled = (): boolean =>
  process.env.REACT_APP_LEGAL_MAILING_ENABLED === 'true';
